import { createContext, useContext } from "solid-js"
import type { RemoteWorkspace } from "@opencode/schema/remote-workspace"
import type { SairAccountContext } from "@/sair/account"

export type CloudConnection = Omit<RemoteWorkspace.Connection, "password">

export type CloudWorkspace = {
  account: SairAccountContext
  state: {
    busy: boolean
    phase: string
    error?: string
    errorMessage?: string
    connection?: CloudConnection
  }
  available: () => boolean
  ensureRemote: (signal?: AbortSignal, force?: boolean) => Promise<CloudConnection>
  reconnect: (signal: AbortSignal) => Promise<{ url: string }>
  details: (key: string) => Promise<RemoteWorkspace.Details>
  sshKey: (key: string) => Promise<RemoteWorkspace.InitialSSHKey>
  resize: (key: string, input: RemoteWorkspace.Resize) => Promise<void>
}

export const CloudWorkspaceContext = createContext<CloudWorkspace>()
export const useCloudWorkspace = () => useContext(CloudWorkspaceContext)
